import React from 'react'
import cx from 'classnames'

const TableBody = ({ children, className }) => {
  return <tbody className={cx(className)}>{children}</tbody>
}

export default TableBody
